import { httpClient } from './httpClient';

export const fetchUser = async () => {
  const response = await httpClient.get(`/users/user`);
  return response.data;
};

export const resetPassword = async (password, confirmPassword) => {
  const response = await httpClient.post(`/users/reset-password`, {
    password,
    confirm_password: confirmPassword,
  });
  return response.data;
};

export const registerPayment = async (companyId, campaignCode) => {
  const response = await httpClient.post(`/users/register-payment`, {
    company_id: companyId,
    campaign_code: campaignCode,
  });
  return response.data;
};

export const cancelMembership = async (subscriptionId) => {
  const response = await httpClient.post(`/users/cancel-membership`, {
    subscription_id: subscriptionId,
  });
  return response.data;
};

export const findOriginalPlan = async (priceId) => {
  const response = await httpClient.post('/users/find-original', {
    price_id: priceId,
  });
  return response.data;
};

export const resetInformation = async (email, phoneNumber) => {
  const response = await httpClient.put(`/users/reset-userinformation`, {
    email,
    phone_number: phoneNumber,
  });
  return response.data;
};

export const getSessionId = async (linkageIdentifier) => {
  const response = await httpClient.get(
    `/users/${linkageIdentifier}/user-sessionid`
  );
  return response.data;
};

export const getPortalSession = async (linkageIdentifier) => {
  const response = await httpClient.post('/stripe/portal-session', {
    linkage_identifier: linkageIdentifier,
  });
  return response.data;
};
